<script setup>
  import { useUserStore } from "@/stores/UserStore";
  import RadioControl from '@/components/RadioControl.vue';

  const userStore = useUserStore();

  const options = {
    f: 'Fahrenheit',
    c: 'Celsius'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'unit-temp-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="userStore.unitsTemp"
                name="unit-temp"
                :id="'unit-temp-' + value"
                :value="value"
                :srLabel="'Select ' + label + ' for temperature units'"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
